import React from 'react';
import { Toggle } from 'components/toggle/Toggle';
import { ProductType } from 'types/orderTypes';

interface PlannerProductTypeProps {
  value: ProductType;
  onUpdate: (product: ProductType) => void;
}

export const PlannerProductType = (props: PlannerProductTypeProps) => {
  const onToggle = (value: string | number) => {
    props.onUpdate(value as ProductType);
  };

  return (
    <div className="button-toggle">
      <Toggle
        values={[
          {
            value: ProductType.delivery,
            label: 'DELIVERY',
          },
          {
            value: ProductType.large,
            label: 'LARGE (QBB)',
          },
        ]}
        value={props.value}
        onClick={onToggle}
      />
    </div>
  );
};
